import { render } from "./UserProfileEditor.vue?vue&type=template&id=4333c54a"
import script from "./UserProfileEditor.vue?vue&type=script&lang=js"
export * from "./UserProfileEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__